import React from 'react'
import { Link } from 'gatsby'
import Card from 'components/card'
import Button from 'components/button.js'
import ExternalLink from 'components/external-link.js'
import useGetAllBuilderProducts from 'hooks/useGetAllBuilderProducts'
import { overlayContainer, column, link, label, } from './styles'
import paths from 'data/paths.json'
import store from 'svgs/enginedj.svg'

export default function NavProducts({ isMobile }) {
    const allBuilderProducts = useGetAllBuilderProducts()
    const featuredProduct = allBuilderProducts.find(({ id }) => id === '2bdf49dd12de4725b7eba3a5fec7f78c')
    
    const controllers = [
        '2bdf49dd12de4725b7eba3a5fec7f78c', // system one
        '651a19001e4040d2b334474ca52d97ea', // one mk2
        '5e9b5dc8d3e549eda5dcb25e551c5fac', // performer
        '0a982431c50840d887d4cd032a4cfa92', // four
    ]

    const mixers = [
        'caadd40aa68b476cb47ae36c8fb08900' // seventy
    ]

    return <div css={overlayContainer(4, isMobile)}>
        <div css={column}>
            <p css={label}>Products</p>
            <Link to={paths.root.products.path} css={link}>
                VIEW ALL Products
            </Link>
            <ExternalLink
                to={paths.external.enginedj}
                className='f-primary primary fw-700 uppercase d-flex col a-start g-1 mt-auto'
                style={{
                    gap: 32,
                    fontSize: 18,
                    lineHeight: '85%',
                    letterSpacing: 0.72,
                }}
            >
                <img src={store} alt='' height={19} />
                <div className='d-flex a-center g-1'>
                    <span className='f-primary-compressed'>
                        EXPLORE ENGINE DJ
                    </span>
                    <img
                        src='/svg/external-link-primary.svg'
                        alt=''
                        className='p-relative'
                        style={{ top: 1 }}
                        height={7.5}
                    />
                </div>
            </ExternalLink>
        </div>
        
        <div css={column}>
            <p css={label}>Controllers</p>
            <Link to={paths.root.products.controllers.path} css={link}>
                VIEW ALL Controllers
            </Link>
            {
                allBuilderProducts
                    .filter(({ id }) => controllers.includes(id))
                    .map(product => {
                        const { url, name } = product
                        return(
                            <Link to={url} css={link}>
                                {name.replace('Rane ', '')}
                            </Link>
                        )
                    })
            }
        </div>
        
        <div css={column}>
            <p css={label}>Mixers</p>
            <Link to={paths.root.products.mixers.path} css={link}>
                VIEW ALL Mixers
            </Link>
            {
                allBuilderProducts
                    .filter(({ id }) => mixers.includes(id))
                    .map(product => {
                        const { url, name } = product
                        return(
                            <Link to={url} css={link}>
                                {name.replace('Rane ', '')}
                            </Link>
                        )
                    })
            }

            <p css={label} style={{ marginTop: 64 }}>Legacy</p>
            <Link to={paths.root.products.legacy.path} css={link}>
                VIEW ALL Legacy
            </Link>
        </div>

        <div>
            <Card product={featuredProduct}>
                <Button />
            </Card>
        </div>
    </div>
}
